import { render, staticRenderFns } from "./ViewProductsModal.vue?vue&type=template&id=c7ad1ee6&"
import script from "./ViewProductsModal.vue?vue&type=script&lang=js&"
export * from "./ViewProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports